import { Routes } from '@angular/router';
import { Role } from '../../core/enums/role.enum';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { arquivosRetornoRoutes } from './arquivos-retorno/arquivos-retorno.routes';

export const ajudaCustosRoutes: Routes = [
  {
    path: 'ajuda-custos',
    canActivate: [AuthGuard],
    // canActivateChild: [RoleChildGuard], // desabilitado temporariamente para testes
    data: {
      title: 'Ajuda de Custo',
      breadcrumb: [{ label: 'Ajuda de Custo', url: '/ajuda-custos' }],
    },
    children: [
      ...arquivosRetornoRoutes,
      {
        path: '',
        loadComponent: () =>
          import('./ajuda-custos-hub/ajuda-custos-hub.component').then(
            (m) => m.AjudaCustosHubComponent,
          ),
        data: {
          title: 'Ajuda de Custo',
          breadcrumb: [{ label: 'Ajuda de Custo', url: '/ajuda-custos' }],
        },
      },
      {
        path: 'minhas-solicitacoes',
        loadComponent: () =>
          import('./ajuda-custos.component').then((m) => m.AjudaCustosComponent),
        data: {
          title: 'Solicitações de Ajuda de Custo',
          roles: [Role.AJUDA_CUSTO_VISUALIZAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Minhas Solicitações', url: '/ajuda-custos/minhas-solicitacoes' },
          ],
        },
      },
      {
        path: 'analisar',
        loadComponent: () =>
          import('./ajuda-custos-analise-lista/ajuda-custos-analise-lista.component').then(
            (m) => m.AjudaCustosAnaliseListaComponent,
          ),
        data: {
          title: 'Analisar Ajuda de Custo',
          roles: [Role.AJUDA_CUSTO_SOLICITACAO_LISTAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Analisar Ajuda de Custo', url: '/ajuda-custos/analisar' },
          ],
        },
      },
      {
        path: 'analisar/lote-pagamento',
        loadComponent: () =>
          import('./ajuda-custos-lote-pagamento/ajuda-custos-lote-pagamento.component').then(
            (m) => m.AjudaCustosLotePagamentoComponent,
          ),
        data: {
          title: 'Encaminhar Solicitações em Lote para Pagamento',
          roles: [Role.AJUDA_CUSTO_LOTE_SELECIONAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Analisar Ajuda de Custo', url: '/ajuda-custos/analisar' },
            { label: 'Encaminhar Solicitações em Lote para Pagamento', url: '/ajuda-custos/analisar/lote-pagamento' },
          ],
        },
      },
      {
        path: 'analisar/:id',
        loadComponent: () =>
          import('./ajuda-custos-analise-form/ajuda-custos-analise-form.component').then(
            (m) => m.AjudaCustosAnaliseFormComponent,
          ),
        data: {
          title: 'Análise da Solicitação de Ajuda de Custo',
          roles: [Role.AJUDA_CUSTO_SOLICITACAO_ANALISAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Analisar Ajuda de Custo', url: '/ajuda-custos/analisar' },
            { label: 'Análise da Solicitação' },
          ],
        },
      },
      {
        path: 'solicitar',
        loadComponent: () =>
          import('./ajuda-custos-form/ajuda-custos-form.component').then(
            (m) => m.AjudaCustosFormComponent,
          ),
        data: {
          title: 'Solicitar Ajuda de Custo',
          roles: [Role.AJUDA_CUSTO_SOLICITAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Solicitar', url: '/ajuda-custos/solicitar' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./ajuda-custos-visualizar/ajuda-custos-visualizar.component').then(
            (m) => m.AjudaCustosVisualizarComponent,
          ),
        data: {
          title: 'Visualizar Ajuda de Custo',
          roles: [Role.AJUDA_CUSTO_VISUALIZAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Visualizar', url: '/ajuda-custos/visualizar' },
          ],
          breadcrumbByRole: [
            {
              role: Role.AJUDA_CUSTO_SOLICITACAO_LISTAR,
              breadcrumb: [
                { label: 'Ajuda de Custo', url: '/ajuda-custos' },
                { label: 'Analisar Ajuda de Custo', url: '/ajuda-custos/analisar' },
                { label: 'Visualizar', url: '/ajuda-custos/visualizar' },
              ],
            },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./ajuda-custos-form/ajuda-custos-form.component').then(
            (m) => m.AjudaCustosFormComponent,
          ),
        data: {
          title: 'Editar Ajuda de Custo',
          roles: [Role.AJUDA_CUSTO_EDITAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Editar', url: '/ajuda-custos/editar' },
          ],
        },
      },
      {
        path: 'historico-documentos/:id',
        loadComponent: () =>
          import('./ajuda-custos-historico-documentos/ajuda-custos-historico-documentos.component').then(
            (m) => m.AjudaCustosHistoricoDocumentosComponent,
          ),
        data: {
          title: 'Histórico de Documentos',
          roles: [Role.AJUDA_CUSTO_HISTORICO_DOCUMENTOS],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Histórico de Documentos', url: '/ajuda-custos/historico-documentos' },
          ],
          breadcrumbByRole: [
            {
              role: Role.AJUDA_CUSTO_SOLICITACAO_LISTAR,
              breadcrumb: [
                { label: 'Ajuda de Custo', url: '/ajuda-custos' },
                { label: 'Analisar Ajuda de Custo', url: '/ajuda-custos/analisar' },
                { label: 'Visualizar', url: '/ajuda-custos/visualizar' },
                { label: 'Histórico de Documentos', url: '/ajuda-custos/historico-documentos' },
              ],
            },
          ],
        },
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./ajuda-custos-dashboard/ajuda-custos-dashboard.component').then((m) => m.AjudaCustosDashboardComponent),
        data: {
          title: 'Dashboard - Indicadores e Relatórios Gerenciais',
          roles: [Role.AJUDA_CUSTO_DASHBOARD_VISUALIZAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Dashboard', url: '/ajuda-custos/dashboard' },
          ],
        },
      },
      {
        path: 'lotes-pagamento',
        loadComponent: () =>
          import('./lotes-pagamento/lotes-pagamento-lista/lotes-pagamento-lista.component').then(
            (m) => m.LotesPagamentoListaComponent,
          ),
        data: {
          title: 'Consultar Lotes de Pagamento',
          roles: [Role.LOTE_PAGAMENTO_CONSULTAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Lotes de Pagamento', url: '/ajuda-custos/lotes-pagamento' },
          ],
        },
      },
      {
        path: 'lotes-pagamento/cadastrar',
        loadComponent: () =>
          import('./lotes-pagamento/lotes-pagamento-form/lotes-pagamento-form.component').then(
            (m) => m.LotesPagamentoFormComponent,
          ),
        data: {
          title: 'Cadastrar Lote de Pagamento',
          roles: [Role.LOTE_PAGAMENTO_CADASTRAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Lotes de Pagamento', url: '/ajuda-custos/lotes-pagamento' },
            { label: 'Cadastrar', url: '/ajuda-custos/lotes-pagamento/cadastrar' },
          ],
        },
      },
      {
        path: 'lotes-pagamento/editar/:id',
        loadComponent: () =>
          import('./lotes-pagamento/lotes-pagamento-form/lotes-pagamento-form.component').then(
            (m) => m.LotesPagamentoFormComponent,
          ),
        data: {
          title: 'Editar Lote de Pagamento',
          roles: [Role.LOTE_PAGAMENTO_EDITAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Lotes de Pagamento', url: '/ajuda-custos/lotes-pagamento' },
            { label: 'Editar', url: '/ajuda-custos/lotes-pagamento/editar' },
          ],
        },
      },
      {
        path: 'lotes-pagamento/visualizar/:id',
        loadComponent: () =>
          import('./lotes-pagamento/lotes-pagamento-visualizar/lotes-pagamento-visualizar.component').then(
            (m) => m.LotesPagamentoVisualizarComponent,
          ),
        data: {
          title: 'Visualizar Lote de Ajuda de Custo',
          roles: [Role.LOTE_PAGAMENTO_CONSULTAR],
          breadcrumb: [
            { label: 'Ajuda de Custo', url: '/ajuda-custos' },
            { label: 'Lotes de Pagamento', url: '/ajuda-custos/lotes-pagamento' },
            { label: 'Visualizar', url: '/ajuda-custos/lotes-pagamento/visualizar' },
          ],
        },
      },
    ],
  },
];
